module.exports = __webpack_public_path__ + "img/scikit.964a9ceb.png";